export class Customer {
    constructor(
        public id: string,
        public firstName: string | null,
        public lastName: string | null,
        public emailAddress: string | null,
        public phoneNumber: string | null,
        public notes: string[],
        public foodDrinkPreferences: string | null,
        public vip: boolean,
        public venueId: string,
        public emailAddressAliases: string[],
        public barred: boolean = false,
        public sendFeedbackRequest: boolean = true,
        public cardDetailsNotRequired: boolean = false,
        public depositAmount: number | null = null,
        public numberOfTimesVisited: number | null = null,
        public numberOfNoShowsAndCancellations: number | null = null,
        public latestReviewScore: number | null = null,
        public dateStatisticsUpdated: Date | null = null
    ) { }

    name(): string {
        const nameParts = [this.firstName, this.lastName]
        return nameParts.join(' ').trim()
    }

    updatePhoneNumber(phoneNumber: string | null) {
        this.phoneNumber = phoneNumber
    }

    updateEmailAddress(emailAddress: string | null) {
        this.emailAddress = emailAddress
    }

    updateFirstName(firstName: string | null) {
        this.firstName = firstName
    }

    updateLastName(lastName: string | null) {
        this.lastName = lastName
    }

    note(): string | null {
        return this.notes.length > 0 ? this.notes[0] : null
    }

    updateNote(note: string | null) {
        if (note) {
            this.notes = [note]
        } else {
            this.notes = []
        }
    }

    updateFoodDrinkPreferences(preferences: string | null) {
        this.foodDrinkPreferences = preferences;
    }

    updateVipStatus(isVip: boolean) {
        this.vip = isVip
    }

    updateBarredStatus(isBarred: boolean) {
        this.barred = isBarred
    }

    updateSendFeedbackRequest(sendFeedbackRequest: boolean) {
        this.sendFeedbackRequest = sendFeedbackRequest
    }

    updateCardDetailsNotRequired(notRequired: boolean) {
        this.cardDetailsNotRequired = notRequired
    }

    updateDepositAmount(amount: number | null) {
        this.depositAmount = amount
    }

    updateEmailAddressAliases(aliases: string[]) {
        this.emailAddressAliases = aliases
    }
}
